<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-to-top`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.904 11.099c.06.05.115.105.165.164l7.981 9.433A1.4 1.4 0 0131.982 23H26v20a1 1 0 01-1 1h-2a1 1 0 01-1-1V23h-5.982a1.4 1.4 0 01-1.068-2.304l7.981-9.433a1.4 1.4 0 011.973-.164zM43 4a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h38z"/></svg>
</template>
<script>

export default {
  name: 'IconToTop',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
